
/**
 * Changes made:
 * - 2025-04-28: Enhanced validation schema with more specific rules
 * - Added detailed error messages and strict type checking
 */

import { z } from "zod";

export const valuationFormSchema = z.object({
  vin: z.string()
    .transform(val => val.toUpperCase().trim())
    .pipe(
      z.string()
        .min(17, "VIN: 17 znaków")
        .max(17, "VIN: 17 znaków")
        .regex(/^[A-HJ-NPR-Z0-9]{17}$/, "Nieprawidłowy VIN")
    ),
  mileage: z.string()
    .transform(val => val.replace(/[^0-9]/g, ''))
    .pipe(
      z.string()
        .min(1, "Wymagany")
        .refine(
          (val) => {
            const num = parseInt(val);
            return num > 0 && num < 1000000;
          },
          "0-1,000,000 km"
        )
    ),
  gearbox: z.enum(["manual", "automatic"], {
    required_error: "Wybierz skrzynię",
    invalid_type_error: "Nieprawidłowy typ",
  }),
});

export type ValuationFormData = z.infer<typeof valuationFormSchema>;
